<template>
  <h1>Kontakt # {{ elementId }}</h1>
  <form @submit.prevent="save">
    <div class="form-row">
      <div class="col-8 col-md-4 col-lg-3 col-xl-3">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="name">Name</label>
          </div>
          <input v-model="form.name" class="form-control" id="name" placeholder="">
        </div>
      </div>
      <div v-if="elementId && (form.contactType === '0' || form.contactType === 0)" class="col-8 col-md-4 col-lg-3 col-xl-3">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="responsible">Verantwortlich</label>
          </div>
          <input v-model="form.responsible" class="form-control" id="responsible" placeholder="">
        </div>
      </div>
      <!--      <div class="col-8 col-md-4 col-lg-3 col-xl-2">-->
      <!--        <div class="input-group mb-3">-->
      <!--          <div class="input-group-prepend">-->
      <!--            <label class="input-group-text" for="firstname">Vorname</label>-->
      <!--          </div>-->
      <!--          <input v-model="form.firstname" class="form-control" id="firstname" placeholder="">-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="col-8 col-md-4 col-lg-3 col-xl-2">-->
      <!--        <div class="input-group mb-3">-->
      <!--          <div class="input-group-prepend">-->
      <!--            <label class="input-group-text" for="firstname">Nachname</label>-->
      <!--          </div>-->
      <!--          <input v-model="form.lastname" class="form-control" id="lastname" placeholder="">-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="col-8 col-md-4 col-lg-3 col-xl-3">-->
      <!--        <div class="input-group mb-3">-->
      <!--          <div class="input-group-prepend">-->
      <!--            <label class="input-group-text" for="company">Firma</label>-->
      <!--          </div>-->
      <!--          <input v-model="form.company" class="form-control" id="company" placeholder="">-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="form-row">
      <div class="col-8 col-md-4 col-lg-3 col-xl-2">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="email">E-Mail</label>
          </div>
          <input v-model="form.email" class="form-control" id="email" placeholder="">
        </div>
      </div>
      <div class="col-8 col-md-4 col-lg-3 col-xl-2">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="mobilePhone">Mobiltelefon</label>
          </div>
          <input v-model="form.mobilePhone" class="form-control" id="mobilePhone" placeholder="">
        </div>
      </div>
      <div class="col-8 col-md-4 col-lg-3 col-xl-2">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="phone">Telefon</label>
          </div>
          <input v-model="form.phone" class="form-control" id="phone" placeholder="">
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-8 col-md-4 col-lg-3 col-xl-3">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="street">Straße</label>
          </div>
          <input v-model="form.street" class="form-control" id="street" placeholder="">
        </div>
      </div>
      <div class="col-8 col-md-4 col-lg-3 col-xl-2">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="zip">PLZ</label>
          </div>
          <input v-model="form.zip" class="form-control" id="zip" placeholder="">
        </div>
      </div>
      <div class="col-8 col-md-4 col-lg-3 col-xl-2">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="city">Ort</label>
          </div>
          <input v-model="form.city" class="form-control" id="city" placeholder="">
        </div>
      </div>
    </div>
    <div class="form-row">
      <div class="col-8 col-md-4 col-lg-3 col-xl-2">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="contactType">Typ</label>
          </div>
          <select
              v-model="form.contactType"
              class="custom-select" id="contactType">
            <option>Auswählen..</option>
            <option v-if="elementId && isOwner()" value="0">Inhaber</option>
            <option value="1">Lieferant</option>
            <option value="2">Aufkäufer</option>
          </select>
        </div>
      </div>
      <div v-if="form.contactType === '1' || form.contactType === 1" class="col-8 col-md-4 col-lg-3 col-xl-3">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="regraterId">Aufkäufer</label>
          </div>
          <select
              v-model="form.regraterId"
              class="custom-select" id="regraterId"
              required>
            <option>Auswählen..</option>
            <option
                v-for="regrater in regraters"
                :key="regrater.contactId"
                :value="regrater.contactId">{{ regrater.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div v-if="form.contactType === '1' || form.contactType === 1" class="form-row">
      <div class="col-8 col-md-4 col-lg-3 col-xl-3">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="fleetNumber">LW-Betriebsnummer</label>
          </div>
          <input v-model="form.fleetNumber" class="form-control" id="fleetNumber" placeholder="">
        </div>
      </div>
      <div class="col-8 col-md-4 col-lg-3 col-xl-3">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="supplier_qualityStandard">Qualitäts-Standard</label>
          </div>
          <select
              v-model="form.supplier_qualityStandard"
              class="custom-select" id="supplier_qualityStandard">
            <option>Auswählen..</option>
            <option
                v-for="qualityStandard in qualityStandards"
                :key="qualityStandard.id"
                :value="qualityStandard.id">{{ qualityStandard.name }}
            </option>
          </select>
        </div>
      </div>
      <div v-if="isBioWithUnion()" class="col-8 col-md-4 col-lg-2">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="city">Bio-Verband</label>
          </div>
          <input v-model="form.bio_union" class="form-control" id="bio_union" placeholder="">
        </div>
      </div>
    </div>

    <div class="form-row">
      <div v-if="isBioWithUnion() || isOwner()" class="col-8 col-md-4 col-lg-2">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="city">Bio-Kontrollstelle</label>
          </div>
          <input v-model="form.bio_control_authority" class="form-control" id="bio_control_authority" placeholder="">
        </div>
      </div>
    </div>

    <div v-if="form.contactType === '2' || form.contactType === 2">
      <h2>GrainStory Zugang</h2>
      <div class="form-row">
        <div class="col-8 col-md-4 col-lg-3 col-xl-3">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_accessGranted">Aktiv</label>
            </div>
            <select
                v-model="form.regrater_accessGranted"
                class="custom-select" id="regrater_accessGranted">
              <option value="0">Nein</option>
              <option value="1">Ja</option>
            </select>
          </div>
        </div>
      </div>

      <!-- regrater articles -->
      <h2>Artikel</h2>
      <div class="form-row">
        <!-- Bio AT Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioAT_articleName">Bio AT Artikel</label>
            </div>
            <input v-model="form.regrater_bioAT_articleName" class="form-control" id="regrater_bioAT_articleName"
                   placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioAT_articleNumber">Bio AT Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_bioAT_articleNumber" class="form-control" id="regrater_bioAT_articleNumber"
                   placeholder="">
          </div>
        </div>

        <!-- Bio AT Verband Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioATunion_articleName">Bio AT Verband Artikel</label>
            </div>
            <input v-model="form.regrater_bioATunion_articleName" class="form-control"
                   id="regrater_bioATunion_articleName"
                   placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioATunion_articleNumber">Bio AT Verband Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_bioATunion_articleNumber" class="form-control"
                   id="regrater_bioATunion_articleNumber"
                   placeholder="">
          </div>
        </div>

        <!-- Bio EU Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioEU_articleName">Bio EU Artikel</label>
            </div>
            <input v-model="form.regrater_bioEU_articleName" class="form-control" id="regrater_bioEU_articleName"
                   placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioEU_articleNumber">Bio EU Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_bioEU_articleNumber" class="form-control" id="regrater_bioEU_articleNumber"
                   placeholder="">
          </div>
        </div>

        <!-- Bio GGA Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioGGA_articleName">Bio GGA Artikel</label>
            </div>
            <input v-model="form.regrater_bioGGA_articleName" class="form-control" id="regrater_bioGGA_articleName"
                   placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioGGA_articleNumber">Bio GGA Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_bioGGA_articleNumber" class="form-control" id="regrater_bioGGA_articleNumber"
                   placeholder="">
          </div>
        </div>

        <!-- Bio GGA Verband Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioGGAunion_articleName">Bio GGA Verband Artikel</label>
            </div>
            <input v-model="form.regrater_bioGGAunion_articleName" class="form-control"
                   id="regrater_bioGGAunion_articleName"
                   placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioGGAunion_articleNumber">Bio GGA Verband Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_bioGGAunion_articleNumber" class="form-control"
                   id="regrater_bioGGAunion_articleNumber"
                   placeholder="">
          </div>
        </div>

        <!-- Bio GGA zzU Verband Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioGGAzzuUnion_articleName">Bio GGA zzU Verband Artikel</label>
            </div>
            <input v-model="form.regrater_bioGGAzzuUnion_articleName" class="form-control" id="regrater_bioGGAzzuUnion_articleName" placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioGGAzzuUnion_articleNumber">Bio GGA zzU Verband Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_bioGGAzzuUnion_articleNumber" class="form-control" id="regrater_bioGGAzzuUnion_articleNumber" placeholder="">
          </div>
        </div>

        <!-- Bio Naturland Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioATnaturland_articleName">Bio Naturland Artikel</label>
            </div>
            <input v-model="form.regrater_bioATnaturland_articleName" class="form-control" id="regrater_bioATnaturland_articleName" placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioATnaturland_articleNumber">Bio Naturland Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_bioATnaturland_articleNumber" class="form-control" id="regrater_bioATnaturland_articleNumber" placeholder="">
          </div>
        </div>

        <!-- Bio zzU Verband Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioATzzuUnion_articleName">Bio zzU Verband Artikel</label>
            </div>
            <input v-model="form.regrater_bioATzzuUnion_articleName" class="form-control" id="regrater_bioATzzuUnion_articleName" placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_bioATzzuUnion_articleNumber">Bio zzU Verband Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_bioATzzuUnion_articleNumber" class="form-control" id="regrater_bioATzzuUnion_articleNumber" placeholder="">
          </div>
        </div>

        <!-- Demeter Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_demeter_articleName">Demeter Artikel</label>
            </div>
            <input v-model="form.regrater_demeter_articleName" class="form-control" id="regrater_demeter_articleName" placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_demeter_articleNumber">Demeter Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_demeter_articleNumber" class="form-control" id="regrater_demeter_articleNumber" placeholder="">
          </div>
        </div>

        <!-- Demeter GGA Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_demeterGGA_articleName">Demeter GGA Artikel</label>
            </div>
            <input v-model="form.regrater_demeterGGA_articleName" class="form-control" id="regrater_demeterGGA_articleName" placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_demeterGGA_articleNumber">Demeter GGA Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_demeterGGA_articleNumber" class="form-control" id="regrater_demeterGGA_articleNumber" placeholder="">
          </div>
        </div>

        <!-- Konv. AT Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convAT_articleName">Konv. AT Artikel</label>
            </div>
            <input v-model="form.regrater_convAT_articleName" class="form-control" id="regrater_convAT_articleName"
                   placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convAT_articleNumber">Konv. AT Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_convAT_articleNumber" class="form-control" id="regrater_convAT_articleNumber"
                   placeholder="">
          </div>
        </div>

        <!-- Konv. Backsaat Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convATbs_articleName">Konv. Backsaat Artikel</label>
            </div>
            <input v-model="form.regrater_convATbs_articleName" class="form-control" id="regrater_convATbs_articleName" placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convATbs_articleNumber">Konv. Backsaat Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_convATbs_articleNumber" class="form-control" id="regrater_convATbs_articleNumber" placeholder="">
          </div>
        </div>

        <!-- Konv. EU Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convEU_articleName">Konv. EU Artikel</label>
            </div>
            <input v-model="form.regrater_convEU_articleName" class="form-control" id="regrater_convEU_articleName"
                   placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convEU_articleNumber">Konv. EU Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_convEU_articleNumber" class="form-control" id="regrater_convEU_articleNumber"
                   placeholder="">
          </div>
        </div>

        <!-- Konv. Europa Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convEurope_articleName">Konv. Europa Artikel</label>
            </div>
            <input v-model="form.regrater_convEurope_articleName" class="form-control"
                   id="regrater_convEurope_articleName"
                   placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convEurope_articleNumber">Konv. Europa Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_convEurope_articleNumber" class="form-control"
                   id="regrater_convEurope_articleNumber"
                   placeholder="">
          </div>
        </div>

        <!-- Konv. GGA Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convGGA_articleName">Konv. GGA Artikel</label>
            </div>
            <input v-model="form.regrater_convGGA_articleName" class="form-control" id="regrater_convGGA_articleName"
                   placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convGGA_articleNumber">Konv. GGA Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_convGGA_articleNumber" class="form-control"
                   id="regrater_convGGA_articleNumber" placeholder="">
          </div>
        </div>

        <!-- Konv. GGA Backsaat Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convGGAbs_articleName">Konv. GGA Backsaat Artikel</label>
            </div>
            <input v-model="form.regrater_convGGAbs_articleName" class="form-control" id="regrater_convGGAbs_articleName" placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convGGAbs_articleNumber">Konv. GGA Backsaat Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_convGGAbs_articleNumber" class="form-control" id="regrater_convGGAbs_articleNumber" placeholder="">
          </div>
        </div>

        <!-- Konv. Stmk GGA Artikel -->
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convStmkGGA_articleName">Konv. Stmk GGA Artikel</label>
            </div>
            <input v-model="form.regrater_convStmkGGA_articleName" class="form-control" id="regrater_convStmkGGA_articleName" placeholder="">
          </div>
        </div>
        <div class="col-8 col-md-4">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="regrater_convStmkGGA_articleNumber">Konv. Stmk GGA Artikel-Nr.</label>
            </div>
            <input v-model="form.regrater_convStmkGGA_articleNumber" class="form-control" id="regrater_convStmkGGA_articleNumber" placeholder="">
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-3">
        <button @click="closeForm" type="reset">Abbrechen</button>
      </div>
      <div class="col-5">
        <button type="submit">Speichern</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "ContactEditor",
  data() {
    return {
      form: {
        contactId: 0,
        name: '',
        responsible: '',
        // firstname: '',
        // lastname: '',
        // company: '',
        contactType: 0,
        email: '',
        mobilePhone: '',
        phone: '',
        street: '',
        zip: '',
        city: '',
        supplier_qualityStandard: 0,
        regraterId: '',
        regrater_accessGranted: 0,
        regrater_convAT_articleName: '',
        regrater_convAT_articleNumber: '',
        regrater_bioAT_articleName: '',
        regrater_bioAT_articleNumber: '',
        regrater_convGGA_articleName: '',
        regrater_convGGA_articleNumber: '',
        regrater_bioGGA_articleName: '',
        regrater_bioGGA_articleNumber: '',
        regrater_convEU_articleName: '',
        regrater_convEU_articleNumber: '',
        regrater_bioEU_articleName: '',
        regrater_bioEU_articleNumber: '',
        regrater_convEurope_articleName: '',
        regrater_convEurope_articleNumber: '',
        regrater_bioATunion_articleName: '',
        regrater_bioATunion_articleNumber: '',
        regrater_bioGGAunion_articleName: '',
        regrater_bioGGAunion_articleNumber: '',
        regrater_demeter_articleName: '',
        regrater_demeter_articleNumber: '',
        regrater_demeterGGA_articleName: '',
        regrater_demeterGGA_articleNumber: '',
        regrater_bioGGAzzuUnion_articleName: '',
        regrater_bioGGAzzuUnion_articleNumber: '',
        regrater_bioATnaturland_articleName: '',
        regrater_bioATnaturland_articleNumber: '',
        regrater_bioATzzuUnion_articleName: '',
        regrater_bioATzzuUnion_articleNumber: '',
        regrater_convStmkGGA_articleName: '',
        regrater_convStmkGGA_articleNumber: '',
        regrater_convGGAbs_articleName: '',
        regrater_convGGAbs_articleNumber: '',
        regrater_convATbs_articleName: '',
        regrater_convATbs_articleNumber: '',
        bio_control_authority: '',
        bio_union: '',
        ama_surface_area: '',
        fleetNumber: ''
      }
    }
  },
  props: {
    elementId: {
      type: Number,
      default: null
    }
  },
  computed: {
    qualityStandards() {
      return this.$store.state.qualityStandards
    },
    regraters() {
      return this.$store.state.regrater
    }
  },
  methods: {
    closeForm() {
      this.$emit('closeForm')
    },
    async save() {
      const response = await this.$store.dispatch('cruItem', {name: 'contact', id: this.elementId, data: this.form})
      if (response && response.success === true) {
        this.closeForm()
      }
    },
    loadData(entry) {
      this.form = entry
    },
    isOwner() { console.log(this.form.contactType);
      return this.form.contactType === '0' || this.form.contactType === 0
    },
    isBioWithUnion() {
      //todo: get from qualityStandard
      switch (parseInt(this.form.supplier_qualityStandard)) {
        case 2:
        case 4:
        case 6:
        case 8:
        case 10:
        case 11:
        case 14:
        case 15:
        case 16:
          return true
        default:
          return false
      }
    }
  },
  created() {
    if (this.elementId) {
      this.$store.dispatch('getItem', {name: 'contact', id: this.elementId})
          .then(this.loadData.bind(this))
    }
    this.$store.dispatch('getItemList', {entityName: 'regrater'})
  }
}
</script>

<style scoped>

</style>